import React from 'react';

import type {
	ExtensionKey,
	ExtensionManifest,
	ExtensionType,
} from '@atlaskit/editor-common/extensions/extension-manifest';
import type { ExtensionProvider } from '@atlaskit/editor-common/extensions/extension-provider';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Flex } from '@atlaskit/primitives/components/flex';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';

import { withExtensionManifest } from '../withExtensionManifest';

const itemBodyStyles = xcss({
	display: 'flex',
	flexDirection: 'row',
	flexWrap: 'nowrap',
	justifyContent: 'space-between',
	margin: 'space.200',
	flexGrow: 3,
});

const itemTextStyles = xcss({
	maxWidth: '100%',
	whiteSpace: 'initial',
});

const summaryStyles = xcss({
	font: 'font.body.small',
	color: 'color.text.subtlest',
	marginTop: 'space.050',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
});

type HeaderAfterIconElementProps = {
	extensionManifest: ExtensionManifest;
};
function HeaderAfterIconElement({ extensionManifest }: HeaderAfterIconElementProps) {
	const title = extensionManifest.title;
	const summary = extensionManifest.summary;

	return (
		<Box xcss={itemBodyStyles}>
			{summary ? (
				<Box xcss={itemTextStyles}>
					<div id="context-panel-title" data-testid="context-panel-title">
						{title}
					</div>
					<Box xcss={summaryStyles}>{summary}</Box>
				</Box>
			) : (
				<Flex direction="column" alignItems="center" testId="context-panel-title">
					{title}
				</Flex>
			)}
		</Box>
	);
}

const _default_1: (props: {
	extensionKey: ExtensionKey;
	extensionProvider: ExtensionProvider;
	extensionType: ExtensionType;
}) => React.JSX.Element | null = withExtensionManifest(HeaderAfterIconElement);
export default _default_1;
